import { analytics } from "@/libs/telemetry"
import { getClientId } from "@/libs/telemetry/user"
import { GrowthBook } from "@growthbook/growthbook"
import { getContext, setContext } from "svelte"

const FEATURES_STORE_KEY = Symbol("featuresStore")

export type Features = {
  isOn: (typeof GrowthBook)["prototype"]["isOn"]
  getFeatureValue: (typeof GrowthBook)["prototype"]["getFeatureValue"]
}

class FeaturesStore {
  #gb = new GrowthBook({
    apiHost: __API_URL__.replace("/api", ""), // GrowthBook internally sets the /api path by default
    clientKey: __FEATURES_KEY__,
    enableDevMode: __DEV__,
    trackingCallback: (experiment, result) =>
      analytics.experiment({ id: experiment.key, variant: result.key }),
    disableCache: true,
  })
  #isReady = $state(false)

  constructor(attributes: Record<string, string>) {
    Promise.all([
      this.#gb.setAttributes({
        id: getClientId(),
        version: import.meta.env.VERSION,
        ...attributes,
      }),
      this.#gb.init({ streaming: false }),
    ]).finally(() => (this.#isReady = true))
  }

  get features(): Features {
    return this.#gb
  }
  get isReady() {
    return this.#isReady
  }
}

export const initFeaturesStore = (...params: ConstructorParameters<typeof FeaturesStore>) =>
  setContext(FEATURES_STORE_KEY, new FeaturesStore(...params))
export const getFeaturesStore = () => getContext<FeaturesStore>(FEATURES_STORE_KEY)
